import React,{ Component} from 'react';
import CustomTabs from './CustomTabs';

class CustomDuesTab extends Component{
  
render(){
    return (
      <CustomTabs value={1}/>
    );
  }
}

export default CustomDuesTab